import { Dispatch, IApplicationState } from '../../types/redux';
import { IThunkActionCreator } from '../../utils/redux';
import { trackClickCall } from '../../containers/BuilderCardContainer/tracking';
import { clearCallActive, setCallActive } from './callActive';

const CALL_HANDLE_DELAY_TIME = 10000;

export const call =
  (key: number, name: string, position: number): IThunkActionCreator =>
  (dispatch: Dispatch, getState: () => IApplicationState) => {
    const state = getState();
    const isCallActive = state.call.callActive;

    if (!isCallActive) {
      dispatch(setCallActive());

      setTimeout(() => {
        trackClickCall(key, name, position);

        dispatch(clearCallActive());
      }, CALL_HANDLE_DELAY_TIME);
    }
  };
